module.exports = __webpack_public_path__ + "img/s4-300x46.99613d7d.jpg";